import { z } from "zod";

import { VibeAppIconDataUrlSchema } from "../../../../schemas/VibeApp";
import { VibeAppSchema } from "./core";

// Icon — set / fetch / clear.
//
// Three endpoints rather than three optional fields on the PATCH, because the
// three do genuinely different work: one accepts bytes, one reaches out over
// the network to the app's own homepage, and one deletes. Folding them into
// `UpdateApp` would give that endpoint a body whose fields cannot be combined
// and a latency that depends on which one was sent.

export const SetVibeAppIconPathVarsSchema = z.object({
  id: z.string().uuid()
});

export const SetVibeAppIconBodySchema = z.object({
  /**
   * The image, as a base64 `data:` URL. Decoded, size-checked and re-encoded to
   * a square PNG server-side, so what is stored is never the caller's bytes
   * verbatim — which is also what makes a mislabelled payload (HTML declaring
   * `image/png`) fail on decode rather than on its label.
   */
  dataUrl: VibeAppIconDataUrlSchema
});

export const SetVibeAppIconResponseSchema = z.object({
  app: VibeAppSchema
});

// Fetch the app's own favicon.
//
// Reaches the app over its canonical public URL — platform-composed, never
// caller-supplied, which is what keeps this from being an SSRF surface. A
// PRIVATE app is header-gated at the edge, so the platform injects the app's
// own edge-auth token exactly as it does for agent tool calls.
export const FetchVibeAppIconPathVarsSchema = z.object({
  id: z.string().uuid()
});

export const FetchVibeAppIconResponseSchema = z.object({
  app: VibeAppSchema
});

// Clear the icon — back to the generated monogram.
export const ClearVibeAppIconPathVarsSchema = z.object({
  id: z.string().uuid()
});

export const ClearVibeAppIconResponseSchema = z.object({
  app: VibeAppSchema
});
